import { Tab } from "@renderbus/ui";
import styled from "styled-components";

export const ClientSecondTabs = styled(Tab)<{ isForeign?: boolean }>`
  .ant-tabs-content-holder {
    background: ${(p) => p.theme["theme-1"]};
    padding: 16px 10px 0 16px;
    border-radius: 0 0 0 6px;
  }

  .ant-tabs-nav-list {
    width: 100%;
    height: 32px;
    background: ${(p) => p.theme["color-fill-5"]};
    box-shadow: ${(p) => p.theme["shadow-2"]};
    border-radius: 6px 0 0 0;
    .ant-tabs-tab-active {
      background: ${(p) => p.theme["theme-1"]} !important;
      border-radius: 6px 6px 0 0;
    }
    .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 0;
    }
  }
  &.ant-tabs.ant-tabs-top {
    .ant-tabs-nav {
      height: 32px !important;
      .ant-tabs-ink-bar[style] {
        &::after {
          display: none;
        }
      }
      .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: transparent !important;
        background-image: conic-gradient(
          from 180.33deg at 50.35% 38.24%,
          #42b0ff 0deg,
          #4a88ff 118.21deg,
          #42b0ff 360deg
        );
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .ant-tabs-tab {
        padding: 0;
        min-width: 209px;
        justify-content: center;
        padding: 0 40px;
        .ant-tabs-tab-btn {
          color: ${(p) => p.theme["color-text-2"]};
          font-weight: 600 !important;
          height: 20px;
        }
        :hover {
          background: ${(p) => p.theme["color-fill-5"]};
          .ant-tabs-tab-btn {
            color: transparent !important;
            background-image: conic-gradient(
              from 180.33deg at 50.35% 38.24%,
              #42b0ff 0deg,
              #4a88ff 118.21deg,
              #42b0ff 360deg
            );
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
  }
`;
